import Footer from "@/kyna/includes/Footer";
import HeaderNav from "@/kyna/includes/HeaderNav";
import Link from "next/link";
import { useEffect } from "react";
import Image from "next/image";
import { useQuery } from "react-query";
import { isEmpty } from "lodash";
import { KTGet } from "@/kyna/lib/db";
import format from "date-fns-tz/format";
import { ReactSVG } from "react-svg";

import SuperpowersProgramImg from "../../../public/assets/img/power-of-zero/Superpowers-Program.jpeg";
import HeroZeroImg from "../../../public/assets/img/power-of-zero/The-Heroes-of-Zero.png";
import ResourceImg from "../../../public/assets/img/power-of-zero/Resources-and-Toolkits-for-Parents.jpeg";

const PowerOfZero = () => {
  const {
    data: EventsData,
    status: EventsDataStatus,
    isLoading: EventsIsLoading,
    refetch: EventsIsRefetch,
  } = useQuery(["EventsData"], async () => {
    return await KTGet("/api/events/public/", {
      current_date: new Date(),
      limit: 6,
      orderBy: "id,desc",
      category: "Power of Zero",
      status: "Published",
    });
  });

  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* POWER OF ZERO HEADER */}
      <section
        id="power-of-zero-header"
        className="lg:mt-[100px] mt-[90px] sm:pt-36 pt-24 sm:pb-60 pb-56 sm:px-10 px-6 bg-[url('/assets/img/eard/power-of-zero/power-of-zero-banner.jpg')] bg-cover bg-center bg-no-repeat bg-fixed relative"
      >
        <div className="max-w-[980px] mx-auto relative z-20 py-5">
          <div className="grid grid-cols-1">
            <h2>
              Power of Zero Philippines
            </h2>
          </div>
        </div>
        <div className="bg-black opacity-10 absolute top-0 left-0 right-0 w-full h-full z-10"></div>
        <div className="poz-header-divider"></div>
      </section>

      {/*  */}
      <section className="bg-[#5256a0] pb-20 sm:px-10 px-8 relative z-30">
        <div className="max-w-[950px] mx-auto">
          <div className="grid">
            <h2 className="text-white sm:text-5xl text-4xl leading-tight text-center mb-2">
              Early Years Program
            </h2>
            <p className="text-white sm:text-2xl text-xl text-center">
              Protecting the well-being of children as they navigate their
              digital life{" "}
            </p>
          </div>
          <div className="grid mt-10">
            <div className="max-w-[450px] lg:mx-0 mx-auto">
              <div className="bg-white w-full sm:max-w-[300px] max-w-[250px] sm:mx-0 mx-auto rounded-full p-2">
                <Image
                  src={SuperpowersProgramImg}
                  alt="Superpowers Program"
                  className="rounded-full"
                />
              </div>
              <div className="max-w-[350px] sm:-mt-[70px] -mt-[50px] sm:ml-12 ml-0">
                <div className="relative">
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto relative z-20">
                    <h3 className="text-[#5256a0] sm:text-2xl text-xl text-center mb-0">
                      Superpowers Program
                    </h3>
                  </div>
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto absolute -top-5 sm:h-[72px] h-[70px] w-full z-10 sm:block hidden"></div>
                </div>
                <p className="text-white text-lg text-center mt-3">
                  We have created a variety of lessons and designed learning
                  activities for young children to teach them the essential life
                  skills they need for online and offline lives.
                </p>
              </div>
            </div>

            <div className="max-w-[450px] lg:-mt-[250px] mt-10 ml-auto lg:mr-0 mr-auto">
              <div className="bg-white w-full sm:max-w-[300px] max-w-[250px] sm:mx-0 mx-auto rounded-full p-2">
                <Image
                  src={HeroZeroImg}
                  alt="Superpowers Program"
                  className="rounded-full"
                />
              </div>
              <div className="max-w-[350px] sm:-mt-[70px] -mt-[50px] sm:ml-12 ml-0">
                <div className="relative">
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto relative z-20">
                    <h3 className="text-[#5256a0] sm:text-2xl text-xl text-center mb-0">
                      The Heroes of Zero
                    </h3>
                  </div>
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto absolute -top-5 sm:h-[72px] h-[70px] w-full z-10 sm:block hidden"></div>
                </div>
                <p className="text-white text-lg text-center mt-3">
                  We created original series produced by FableVision designed to
                  teach young children aged 5-8 the life skills they need to
                  navigate in an ever-evolving online world. Watch the full
                  episodes for free!
                </p>
              </div>
            </div>

            <div className="max-w-[450px] lg:-mt-[150px] mt-10 lg:ml-20 ml-auto lg:mr-0 mr-auto">
              <div className="bg-white w-full sm:max-w-[300px] max-w-[250px] sm:mx-0 mx-auto rounded-full p-2">
                <Image
                  src={ResourceImg}
                  alt="Superpowers Program"
                  className="rounded-full"
                />
              </div>
              <div className="max-w-[350px] -mt-[70px] sm:ml-12 ml-0">
                <div className="relative">
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto relative z-20">
                    <h3 className="text-[#5256a0] sm:text-2xl text-xl text-center mb-0">
                      Resources and Toolkits for Parents
                    </h3>
                  </div>
                  <div className="bg-white py-3 sm:px-5 px-4 border-8 border-[#5256a0] sm:max-w-[300px] max-w-[280px] mx-auto absolute -top-5 sm:h-[72px] h-[70px] w-full z-10 sm:block hidden"></div>
                </div>
                <p className="text-white text-lg text-center mt-3">
                  The first device campaign is providing resources for parents
                  and grandparents to support your child's well-being to begin
                  their online journey.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className=""></div>
      </section>

      <section className="-mt-2">
        <div className="grid">
          <div className="text-center">
            <div className="rotate-180">
              <ReactSVG src="assets/img/power-of-zero/purple-divider.svg" />
            </div>

            <div className="py-24 sm:px-10 px-8">
              <h2 className="lg:text-6xl sm:text-5xl text-4xl">
                Download your Parent's Toolkit now
              </h2>
              <p className="sm:text-xl text-lg">
                Your child's first device is an important thing in their lives.
              </p>
              <div className="form-group mt-8">
                <Link href="assets/img/POZ-Parenting-Toolkit-Filipino-V2.pdf">
                  <a
                    target="_blank"
                    id="power-zero-download"
                    className="btn btn-primary rounded-full bg-[#5256a0] text-lg max-w-[180px] w-full mx-auto"
                  >
                    Download
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[url('/assets/img/power-of-zero/ensuring-children-safety-bg.jpg')] bg-fixed bg-cover bg-center bg-no-repeat relative -mt-2">
        <div className="rotate-180 relative -top-2">
          <ReactSVG src="assets/img/power-of-zero/white-divider.svg" />
        </div>
        <div className="py-24 sm:px-10 px-8 grid">
          <div className="text-center max-w-5xl mx-auto">
            <h2 className="lg:text-7xl sm:text-5xl text-4xl text-white">
              Ensuring children's safety and well-being in the digital age
            </h2>
          </div>
        </div>
      </section>

      <section className="border-t-[50px] border-[#6959A2] py-24 sm:px-10 px-8">
        <div className="grid max-w-screen-xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="md:text-5xl text-4xl">
              Watch the Heroes of Zero Philippines
            </h2>
          </div>

          {!isEmpty(EventsData?.data?.result) ? (
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-10 lg:max-w-full max-w-xl mx-auto">
              {EventsData?.data?.result?.map((events, index) => {
                return (
                  <Link
                    className="cursor-pointer"
                    key={`events-${index}`}
                    href={`/news-and-events/${events?.slug}`}
                  >
                    <div className="col-span-1 cursor-pointer bg-white rounded-xl d-flex justify-items-stretch transition duration-300 ease-in-out hover:shadow-2xl">
                      <div className="">
                        <div className="relative w-full xl:h-[280px] lg:h-[230px] sm:h-[280px] h-[250px]">
                          {events?.media?.path ? (
                            <Image
                              className="cursor-pointer object-cover rounded-t-xl"
                              src={events?.media?.path}
                              alt="News and Events"
                              layout="fill"
                            />
                          ) : null}
                        </div>
                        <div className="relative">
                          <p className="text-white font-semibold uppercase absolute right-0 bg-[#95d50b] py-1 px-4">
                            {format(new Date(events?.post_date), "PP")}
                          </p>
                          <div className="py-8 px-8">
                            <h3 className="text-lg pt-6">{events.title}</h3>
                            <p className="">{events.excerpt}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          ) : (
            <div className="px-2 text-center">
              <div className="text-gray-500 ">
                No events posted.
                {/* <pre>{JSON.stringify(EventsData?.data?.result,null,1)}</pre> */}
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="bg-[#5256a0] py-16 sm:px-10 px-8 hidden">
        <div className="grid">
          <div className="text-center max-w-5xl mx-auto">
            <h2 className="text-white text-4xl font-CantoraOne italic leading-snug">
              "This program helped numerous families guide their children
              navigate the online platform healthily, especially emphasizing how
              important it is to become involved with their childrens' life both
              online and offline."
            </h2>
            <p className="text-white text-xl">
              Teacher Jane Torres, From Balumbato Elementary School
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default PowerOfZero;
